import * as Types from '../../../generated/graphql';

import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateUnauthenticatedRsvpMutationVariables = Types.Exact<{
  data: Types.CircleCreateUnauthenticatedRsvpDataInput;
}>;


export type CreateUnauthenticatedRsvpMutation = (
  { __typename: 'Mutation' }
  & { circleCreateUnauthenticatedRsvp?: Types.Maybe<(
    { __typename: 'CircleRsvpSuccessful' }
    & Pick<Types.CircleRsvpSuccessful, 'rsvpId'>
  ) | { __typename: 'CirclePermissionDeniedError' } | { __typename: 'CircleNotFoundError' } | (
    { __typename: 'CircleValidationError' }
    & Pick<Types.CircleValidationError, 'message'>
  ) | (
    { __typename: 'CircleProcessingError' }
    & Pick<Types.CircleProcessingError, 'message'>
  ) | { __typename: 'CircleSessionSeatLimitExceededError' } | (
    { __typename: 'CircleSessionAlreadyStartedError' }
    & Pick<Types.CircleSessionAlreadyStartedError, 'message'>
  ) | { __typename: 'CircleSeriesAccessTypeNotAllowedError' }> }
);

export type CancelUnauthenticatedRsvpMutationVariables = Types.Exact<{
  rsvpId: Types.Scalars['ID'];
  token: Types.Scalars['String'];
}>;


export type CancelUnauthenticatedRsvpMutation = (
  { __typename: 'Mutation' }
  & { circleCancelUnauthenticatedRsvp: (
    { __typename: 'CircleRsvpCancellationSuccessful' }
    & Pick<Types.CircleRsvpCancellationSuccessful, 'rsvpState'>
  ) | { __typename: 'CirclePermissionDeniedError' } | { __typename: 'CircleNotFoundError' } | { __typename: 'CircleSessionAlreadyStartedError' } }
);


export const CreateUnauthenticatedRsvpDocument = gql`
    mutation createUnauthenticatedRsvp($data: CircleCreateUnauthenticatedRsvpDataInput!) {
  circleCreateUnauthenticatedRsvp(data: $data) {
    __typename
    ... on CircleRsvpSuccessful {
      rsvpId
    }
    ... on CircleProcessingError {
      message
    }
    ... on CircleValidationError {
      message
    }
    ... on CircleSessionAlreadyStartedError {
      message
    }
  }
}
    `;
export type CreateUnauthenticatedRsvpMutationFn = Apollo.MutationFunction<CreateUnauthenticatedRsvpMutation, CreateUnauthenticatedRsvpMutationVariables>;

/**
 * __useCreateUnauthenticatedRsvpMutation__
 *
 * To run a mutation, you first call `useCreateUnauthenticatedRsvpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnauthenticatedRsvpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnauthenticatedRsvpMutation, { data, loading, error }] = useCreateUnauthenticatedRsvpMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUnauthenticatedRsvpMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnauthenticatedRsvpMutation, CreateUnauthenticatedRsvpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnauthenticatedRsvpMutation, CreateUnauthenticatedRsvpMutationVariables>(CreateUnauthenticatedRsvpDocument, options);
      }
export type CreateUnauthenticatedRsvpMutationHookResult = ReturnType<typeof useCreateUnauthenticatedRsvpMutation>;
export type CreateUnauthenticatedRsvpMutationResult = Apollo.MutationResult<CreateUnauthenticatedRsvpMutation>;
export type CreateUnauthenticatedRsvpMutationOptions = Apollo.BaseMutationOptions<CreateUnauthenticatedRsvpMutation, CreateUnauthenticatedRsvpMutationVariables>;
export const CancelUnauthenticatedRsvpDocument = gql`
    mutation cancelUnauthenticatedRsvp($rsvpId: ID!, $token: String!) {
  circleCancelUnauthenticatedRsvp(rsvpId: $rsvpId, rsvpEditToken: $token) {
    ... on CircleRsvpCancellationSuccessful {
      rsvpState
    }
  }
}
    `;
export type CancelUnauthenticatedRsvpMutationFn = Apollo.MutationFunction<CancelUnauthenticatedRsvpMutation, CancelUnauthenticatedRsvpMutationVariables>;

/**
 * __useCancelUnauthenticatedRsvpMutation__
 *
 * To run a mutation, you first call `useCancelUnauthenticatedRsvpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUnauthenticatedRsvpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUnauthenticatedRsvpMutation, { data, loading, error }] = useCancelUnauthenticatedRsvpMutation({
 *   variables: {
 *      rsvpId: // value for 'rsvpId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCancelUnauthenticatedRsvpMutation(baseOptions?: Apollo.MutationHookOptions<CancelUnauthenticatedRsvpMutation, CancelUnauthenticatedRsvpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUnauthenticatedRsvpMutation, CancelUnauthenticatedRsvpMutationVariables>(CancelUnauthenticatedRsvpDocument, options);
      }
export type CancelUnauthenticatedRsvpMutationHookResult = ReturnType<typeof useCancelUnauthenticatedRsvpMutation>;
export type CancelUnauthenticatedRsvpMutationResult = Apollo.MutationResult<CancelUnauthenticatedRsvpMutation>;
export type CancelUnauthenticatedRsvpMutationOptions = Apollo.BaseMutationOptions<CancelUnauthenticatedRsvpMutation, CancelUnauthenticatedRsvpMutationVariables>;